import { Routes } from '@angular/router';
import { authGuard, stageGuard } from "../../_shared/helpers";
import { ContactsComponent } from "./contacts/contacts.component";
import { ContactCustomersComponent } from "./contact-customers/contact-customers.component";
import { ContactSuppliersComponent } from "./contact-suppliers/contact-suppliers.component";
import { ContactDetailsComponent } from "./contact-details/contact-details.component";
import {ContactAddComponent} from "./contact-add/contact-add.component";
import {ContactUpdateComponent} from "./contact-update/contact-update.component";

export const CONTACT_ROUTES: Routes = [
  {
    path: 'contacts',
    pathMatch: 'full',
    redirectTo: 'contacts/overview'

  },
  {
    path: 'contacts/overview',
    component: ContactsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'contacts/customer',
    component: ContactCustomersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'contacts/suppliers',
    component: ContactSuppliersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'contact/details/:cid',
    component: ContactDetailsComponent,
    canActivate: [authGuard]
  },
  {
    // Schreibt ueber crm_sync in das produktive TecArt, das sich DEV und UAT
    // teilen -- deshalb zusaetzlich der stageGuard.
    path: 'contact/update/:cid',
    component: ContactUpdateComponent,
    canActivate: [authGuard, stageGuard]
  },
  {
    // dito
    path: 'contact/add',
    component: ContactAddComponent,
    canActivate: [authGuard, stageGuard]
  }
];
